import { Link } from 'react-router-dom'
import Panel from '../../ui/Panel'
import { useSavedTests } from '../../hooks/useSavedTests'
import { formatDate } from '../../lib/format'
import { leakTest } from '../../content/site'
import styles from './SavedTests.module.css'

export default function SavedTests() {
    const { tests, remove } = useSavedTests()

    // nothing saved yet: an empty panel would only be noise
    if (tests.length === 0) return null

    return (
        <Panel title={leakTest.saved.heading} className={styles.panel}>
            <p className={styles.note}>{leakTest.saved.note}</p>
            <ul className={styles.list}>
                {tests.map((test) => (
                    <li key={test.id} className={styles.row}>
                        <Link to={`/dns-leak-test/${test.id}`} className={styles.link}>
                            {formatDate(test.createdAt)}
                        </Link>
                        <span className={styles.id}>{test.id}</span>
                        <button type="button" className={styles.remove}
                            onClick={() => remove(test.id)}
                            aria-label={`Forget test from ${formatDate(test.createdAt)}`}>
                            {leakTest.saved.forget}
                        </button>
                    </li>
                ))}
            </ul>
        </Panel>
    )
}
